import { useHotkeys } from "react-hotkeys-hook";

const MOVEMENT_KEYS = "left,right,a,d";
const ACTION_KEYS = "esc";
const FIGHT_ATTACK_KEYS = "1,2,3,4,5";
const FIGHT_SKILL_KEYS =
  "shift+1,shift+2,shift+3,shift+4,shift+5,shift+6,shift+7,shift+8,shift+9,shift+0";

const KEYBOARD_KEYS = `${MOVEMENT_KEYS},${ACTION_KEYS},${FIGHT_ATTACK_KEYS},${FIGHT_SKILL_KEYS}`;

export const useKeyboardControls = (
  onInputStart: (command: string) => void,
  onInputEnd: (command: string) => void
) => {
  // Key down
  useHotkeys(KEYBOARD_KEYS, (event, handler) => {
    event.preventDefault();
    onInputStart(handler.shortcut);
  });

  // Key up
  useHotkeys(
    KEYBOARD_KEYS,
    (event, handler) => {
      event.preventDefault();
      onInputEnd(handler.shortcut);
    },
    { keyup: true }
  );
};
